import React, { createContext, useContext, ReactNode } from 'react';

interface EventContextType {
  nextLanEvent: {
    name: string;
    startDate: Date;
    endDate: Date;
    location: string;
  }
}

// Create a context with a default value
const EventContext = createContext<EventContextType | undefined>(undefined);

// Create a provider component
export const EventProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Define the next LAN event details
  // November 28, 2025 at 8:00 PM Danish time (CET)
  const nextLanEvent = {
    name: 'Winter invitational LAN showdown',
    startDate: new Date('2025-11-28T20:00:00+01:00'), // 8 PM CET
    endDate: new Date('2025-11-30T23:59:00+01:00'),   // End of day CET
    location: 'Klaus Berntsensvej 19, 5471 Søndersø'
  };

  const value = { nextLanEvent };

  return (
    <EventContext.Provider value={value}>
      {children}
    </EventContext.Provider>
  );
};

// Create a hook to use the event context
export const useEvent = (): EventContextType => {
  const context = useContext(EventContext);
  
  if (context === undefined) {
    throw new Error('useEvent must be used within an EventProvider');
  }
  
  return context;
};